import styled from '@emotion/styled'
import { ButtonHTMLAttributes } from 'react'

type DurationButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  isSelected?: boolean
}

export const DurationButton = styled.button<DurationButtonProps>`
  border: none;
  background-color: ${props => (props.isSelected ? 'var(--Red-Dark)' : 'var(--White90)')};
  font-weight: ${props => (props.isSelected ? 'bold' : 'normal')};
  color: ${props => (props.isSelected ? 'var(--White)' : 'var(--Graphite)')};
  padding: 6px;
  cursor: pointer;
  &:hover {
    background-color: var(--Red-Dark);
    color: var(--White);
  }
`
